import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  signal,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'seech-shared-chip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent implements OnChanges, OnInit {
  @Input({ required: true }) description!: string;
  @Input() value!: string;
  @Input() color?: string;
  @Input() image?: string;
  @Input() fill?: 'solid' | 'outline' = 'solid';
  @Input() id?: string | number;
  @Input() readonly = false;
  classes = signal<string[]>([]);

  // input to turn on and off the image placeholder
  @Input() createAvatar = true;
  // input to turn on and off the cancel button
  @Input() cancelable = false;

  @Output() cancelEvent = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['readonly']) {
      this.getChipClasses();
    }
  }

  ngOnInit(): void {
    this.getChipClasses();
  }

  getChipClasses() {
    const classes = [
      `sch-chip-${this.color}`,
      `${this.readonly ? 'sch-chip readonly' : 'sch-chip'}`,
    ];
    if (this.fill === 'solid') {
      classes.push('filled');
    } else {
      classes.push('outlined');
    }
    this.classes.set(classes);
  }

  onCancel(): void {
    this.cancelEvent.emit();
  }

  // getFirstLetter(text: string): string {
  //   // remove spaces from the beginning and the end
  //   text = text.trim();
  //   // remove double or more spaces
  //   text = text.replace(/\s{2,}/g, ' ');
  //   // get first letter
  //   return text.charAt(0).toUpperCase();
  // }

  getFirstLetter(text: string): string {
    // provide a default value if text is undefined
    text = text ?? '';

    // remove spaces from the beginning and the end
    text = text.trim();

    // remove double or more spaces
    text = text.replace(/\s{2,}/g, ' ');

    // get first letter
    return text.charAt(0).toUpperCase();
  }
}
